import { render, staticRenderFns } from "./BpjsKesehatanDetail.vue?vue&type=template&id=1a1995f0&"
import script from "./BpjsKesehatanDetail.vue?vue&type=script&lang=js&"
export * from "./BpjsKesehatanDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports